import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { notification, Select } from 'antd';

import { Button, Input, Form, Space } from 'antd';

import FormHeader from '@controls/form-header/form-header';
import IBaseComponentProps from '@components/base-component-props';

import { exception } from '@extensions/notification';
import { getEnumList } from '@extensions/utils';

import { userLoaded } from '@store/actions';
import { useAppDispatch } from '@store/hooks';

import { ICompany } from '@entities/company';

import { IEnumItem } from '@enums/enum-item';
import { CompanyType, enumLabel } from '@enums/company-type';

const Company = (props: IBaseComponentProps) => {
    const { serverFetch } = props;

    const { id } = useParams();

    const navigate = useNavigate();
    const [api, contextHolder] = notification.useNotification();

    const d = useAppDispatch();

    const { TextArea } = Input;

    const [types] = useState<Array<IEnumItem>>(getEnumList(CompanyType, enumLabel));

    const [entity, setEntity] = useState<ICompany>({
        id: undefined,
        type: undefined,
        legalName: undefined,
        details: undefined,
    });
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (!id) {
            return;
        }

        setLoading(true);

        serverFetch(`companies/${id}`, { method: 'GET' })
            .then((data: any) => {
                setEntity(data);
                setLoading(false);
            })
            .catch((ex: any) => {
                exception(api, 'Ошибка получения компании', ex, () => d(userLoaded(undefined)));
                setLoading(false);
            });
    }, []);

    const onSave = () => {
        setLoading(true);

        serverFetch(`companies`, { method: id ? 'PUT' : 'POST', bodyData: entity })
            .then(() => {
                setLoading(false);
                navigate(-1);
            })
            .catch((ex: any) => {
                setLoading(false);
                exception(api, 'Ошибка сохранения компании', ex, () => d(userLoaded(undefined)));
            });
    };

    return (
        <>
            <FormHeader title={`${id ? 'Изменить компанию' : 'Добавить компанию'}`} />
            {!loading && (
                <Form colon={false} labelCol={{ span: 3 }} wrapperCol={{ span: 8 }} onFinish={onSave}>
                    <Form.Item
                        initialValue={entity.legalName}
                        required
                        label='Название'
                        name='legalName'
                        rules={[{ required: true, message: 'Укажите название ' }]}
                    >
                        <Input
                            autoFocus
                            onChange={(data) => {
                                setEntity({ ...entity, legalName: data.target.value });
                            }}
                        />
                    </Form.Item>
                    <Form.Item initialValue={entity.type} label='Тип' name='type' rules={[{ required: true, message: 'Укажите тип ' }]}>
                        <Select
                            key='type'
                            allowClear
                            onChange={(value) => {
                                setEntity({ ...entity, type: value });
                            }}
                            options={types.map((t) => {
                                return { value: t.value, label: t.label };
                            })}
                        />
                    </Form.Item>
                    <Form.Item
                        initialValue={entity?.details}
                        required
                        label='Реквизиты'
                        name='details'
                        rules={[{ required: true, message: 'Укажите реквизиты' }]}
                    >
                        <TextArea
                            rows={10}
                            onChange={(data) => {
                                setEntity({ ...entity, details: data.target.value });
                            }}
                        />
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 3, span: 8 }}>
                        <Space size={'small'} style={{ float: 'right' }}>
                            <Button type='text' onClick={() => navigate(-1)}>
                                Отменить
                            </Button>
                            <Button type='primary' htmlType='submit' loading={loading}>
                                Сохранить
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            )}

            {contextHolder}
        </>
    );
};

export default Company;
